import axios from "axios";
import { baseURL } from "../globals/constants";

const headers = () => ({ headers: { Accept: "application/json", Authorization: `Bearer ${localStorage.getItem("access_token")}` } });

export interface ConsentSummary {
  participants: number;
  accepted: number;
  declined: number;
  notAnswered: number;
  version: string;
}
export interface ConsentAnswer {
  participantId: string;
  name: string;
  phoneNumber: string;
  answer: "accepted" | "declined";
  version: string;
  answeredAt: string;
}

/** Totals: how many participants accepted / declined the information about their data */
export const getConsentSummary = async (breefId: string): Promise<ConsentSummary | null> => {
  try {
    return (await axios.get(`${baseURL}/v1/privacy/breefs/${breefId}/consents/summary`, headers())).data;
  } catch {
    return null;
  }
};

/** Every answer with the participant's name - support mode (the API asks for a reason, 428) */
export const getConsentAnswers = async (breefId: string): Promise<ConsentAnswer[] | null> => {
  try {
    return (await axios.get(`${baseURL}/v1/privacy/breefs/${breefId}/consents`, headers())).data;
  } catch {
    return null;
  }
};
